/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import Tour from 'reactour';
import { Trans } from 'react-i18next';

import LayoutSimple from '../components/LayoutSimple.jsx';
import NavigatorSimple from '../components/NavigatorSimple.jsx';
import Map from '../components/Map.jsx';
import OptionMapSelectorSimple from '../components/OptionMapSelectorSimple.jsx';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {createTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';

import LocalStorage from '../service/LocalStorage';

import i18n from '../resources/i18n';
import {properties} from '../resources/properties.js';

declare var M;
const plugin = new M.plugin.Mapaalacarta({enabled: true});
// const xylocator = new M.plugin.XYLocator();
const ignsearch = new M.plugin.IGNSearch({
  urlFind : properties.urlGeocoder+"/api/geocoder/findJsonp",
  urlCandidates : properties.urlGeocoder+"/api/geocoder/candidatesJsonp", 
  urlReverse : properties.urlGeocoder+"/api/geocoder/reverseGeocode",
  servicesToSearch: "g",
  maxResults: 30,
  noProcess:"expendeduria"
});
const fullviewmap = new M.plugin.FullViewMap({
  position: 'BL',
});
const scaleZoomPlugin = new M.plugin.ScaleZoom(plugin);
const insertPhotoPlugin = new M.plugin.InsertPhoto({
  position: 'BL',
});
// xylocator
const pluginList = [plugin, ignsearch, scaleZoomPlugin, fullviewmap, insertPhotoPlugin];

const sizeImageCustomUnit = (properties.MAX_POST_SIZE / 1048576 >= 1)
  ? (Math.round(properties.MAX_POST_SIZE / 1048576) + ' MB')
  : (Math.round(properties.MAX_POST_SIZE / 1024) + ' KB');

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class Step1S extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerX: -417002.20780977904,
      centerY: 4931965.4853014955,
      isTourOpen: false,
      showModalBarCode: false,
    };
    const {parentState} = this.props;
    parentState.isSimple = true;
    parentState.seleccionadoProductoSeries = 'Elaborado';
    this.handleShowBarCode = this.handleShowBarCode.bind(this);
    this.handleCloseBarCode = this.handleCloseBarCode.bind(this);
    //TestAdminUSER
    let testLogin = LocalStorage.get('login-cookie');// POSIBLEMENTE ES MEJOR MOVERLO FUERA DE AQUí con otro metodo de saber su estado antes de llegar aquí
    if(testLogin && testLogin.fecha > new Date().getTime()){
      this.props.parentState.specialMapGeneration = (testLogin.token === properties.TOKEN);
      this.props.parentState.author = 'CNIG';
    }else{
      LocalStorage.delete('login-cookie');
      this.props.parentState.specialMapGeneration = false;
      delete this.props.parentState.nipo;
      delete this.props.parentState.isbn;
      delete this.props.parentState.depositoLegal;
      delete this.props.parentState.codigoBarras;
      delete this.props.parentState.realCodigoBarras;
      delete this.props.parentState.specialFileName;
    }
    testLogin = null;
    //TestAdminUSER
    this.setStateGlobal(parentState);
  }

  setStateGlobal = (state) => {
    const {setParentState} = this.props;
    setParentState(state);
  }
  setModal = (mapa, state) => {
    const {setModal} = this.props;
    setModal(mapa, state);
  }
  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  setMapa = (map) => {
    let {parentState} = this.props;
    parentState.mapa = map;
    this.setStateGlobal(parentState);
  };

  convertScaleValueToScaleFactor(scaleValue) {
    var scaleFactor = 0;
    switch (scaleValue) {
      case '1:25.000':
        scaleFactor = 25;
        break;
      case '1:30.000':
        scaleFactor = 30;
        break;
      case '1:20.000':
        scaleFactor = 20;
        break;
      case '1:40.000':
        scaleFactor = 40;
        break;
      case '1:50.000':
        scaleFactor = 50;
        break;
      case '1:60.000':
        scaleFactor = 60;
        break;
      default:
        scaleFactor = 25;
    }

    return scaleFactor;
  }

  setScaleValue = (event) => {
    let {parentState} = this.props;
    parentState.scale = event;
    this.setStateGlobal(parentState);
    switch (event) {
      case '1:25.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '25K';
        parentState.scaleCm = '250 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 25);
        parentState.previousScale = event;
        parentState.zoom = 12;
        break;
      case '1:30.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '30K';
        parentState.scaleCm = '300 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 30);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      case '1:20.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '20K';
        parentState.scaleCm = '200 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 20);
        parentState.previousScale = event;
        parentState.zoom = 12;
        break;
      case '1:50.000':
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '50K';
        parentState.scaleCm = '500 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 50);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      case '1:40.000':
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '40K';
        parentState.scaleCm = '400 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 40);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      default:
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '60K';
        parentState.scaleCm = '600 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 60);
        parentState.previousScale = event;
        parentState.zoom = 10;
        break;
    }

    this.setStateGlobal(parentState);
    if(window.mapJs.getZoom()<parentState.zoom){
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);//plugin.setMapCenter(parentState.mapa);
    }

    // actualizar escala del plugin insertPhoto
    const scaleDenominator = parseFloat(event.replace('1:', '').replace('.', ''));
    insertPhotoPlugin.updateScale(scaleDenominator);

    return parentState.scale;
  }

  closeTour = () => {
    this.setState({isTourOpen: false});
  }

  openTour = () => {
    this.setState({isTourOpen: true});
  }

  setOrientation = (event) => {
    let {parentState} = this.props;
    if (parentState.previousOrientation !== parentState.orientation) {
      // this.setState({orientation: event});
      plugin.rotate(event);
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);
      parentState.orientation = event;
      this.setStateGlobal(parentState);

    }
    this.setStateGlobal(parentState);
  }

  handleShowBarCode() {
    this.setState({showModalBarCode: true});
  }
  handleCloseBarCode() {
    this.setState({showModalBarCode: false});
  }

  render() {
    const {parentState} = this.props;

    scaleZoomPlugin.setState(parentState);
    scaleZoomPlugin.setCallbackState(this.setStateGlobal);
    const {centerX, centerY, isTourOpen} = this.state;
    const steps = [
      {
        selector: '.first-step',
        content: i18n.t('tour.step1FirstStep'),
      },
      {
        selector: '.showGridHelp',
        content: i18n.t('tour.mapHelpStep1'),
      },
      {
        selector: '.second-step',
        content: i18n.t('tour.step1SecondStep'),
        style: {
          whiteSpace: "pre-line",
          padding: "24px 40px",
        },
      },
      {
        selector: '.third-step',
        content: parentState.specialMapGeneration ? i18n.t('tour.specialStep2') : i18n.t('tour.step1Or2Parameters'),
      },
      {
        selector: '.fifth-step',
        content: i18n.t('tour.step1FifthStep'),
      },
      {
        selector: '.search-panel',
        content: i18n.t('tour.step1SixthStep'),
      },
      {
        selector: '.m-scalezoom',
        content: i18n.t('tour.step1TenthStep'),
      },
      {
        selector: '#container-button2',
        content: i18n.t('tour.step1EleventhStep'),
      },
      {
        selector: '.m-plugin-fullviewmap',
        content: i18n.t('tour.step1EighthStep'),
      },
    ]

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = i18n.t('step1.leftLabelTextTittle');
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = i18n.t('step1.leftLabelDescription');
    const leftBarClassName = 'bar';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name';
    const centerLabelTextTittle = i18n.t('step1.centerLabelTextTittle');
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = i18n.t('step1.centerLabelDescription');
    const rightBarClassName = 'bar';
    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name';
    const rightLabelTextTittle = i18n.t('step1.rightLabelTextTittle');
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = i18n.t('step1.rightLabelDescription');

    //StepBody
    const stepClassName = 'step1'
    const sectionClassName = 's1-left';
    const asideClassName = 's1-right';

    //Next and previous pages
    const nextPage = '/Step2';
    const previousPage = '/main';

    // classes
    const classPanelContent = 'panel-content';
    const classPanelButton = 'panel-button';

    return (<React.Fragment>
      <LayoutSimple setParentStateSteps={this.setStateGlobalStep} parentState={parentState} inforCoords={parentState.inforFeatureCoordinates[0]} label={null} activeRow={this.props.activeRow} nextPage={nextPage} previousPage={previousPage} isStep3={0}>
        <Dialog open={this.state.showModalBarCode} onClose={this.handleCloseBarCode} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle color="primary" id="alert-dialog-title">
            <Trans i18nKey="dialog.uploadImage">
              Subir Imagen
            </Trans>
            </DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.errorHeavyFile">
              La imagen que ha seleccionado excede el tamaño límite establecido</Trans> ({sizeImageCustomUnit})
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseBarCode}>
              <Trans i18nKey="dialog.back">
                Volver
              </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <NavigatorSimple leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorSimple>
        <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={this.closeTour} />
        <h1>
          <i className="mc-design"></i>
          <label>
          <Trans i18nKey="step1.mapDesign">
            Diseño del mapa
          </Trans>
          </label>
        </h1>
        <div className={stepClassName}>
          <section className={sectionClassName}>
            <div className="fifth-step">
              <Map setModal={this.setModal} setParentState={this.setStateGlobal} location={this.props.location} parentState={parentState} pluginList={pluginList} M={M} centerX={centerX} centerY={centerY} mapa={this.setMapa} isSimple={true}></Map>{/*pluginEdition={editionTools}*/}
            </div>
            <br/>
            <a onClick={this.openTour}>
              <label id="download-tui-image" className="inputfile generalHelpButton">
                <Trans i18nKey="wizardPanel.help">Ayuda</Trans>
              </label>
            </a>
          </section>
          <OptionMapSelectorSimple setParentState={this.setStateGlobal} parentState={parentState} actionScale={this.setScaleValue} actionOrientation={this.setOrientation} actionShowBarCodePopup={this.handleShowBarCode} scaleValueChild={parentState.scale} activeRow={this.props.activeRow} asideClassName={asideClassName} classPanelButton={classPanelButton} classPanelContent={classPanelContent}/>
        </div>
      </LayoutSimple>
    </React.Fragment>);
  }
}

export default Step1S;
